module.exports = __webpack_public_path__ + "img/12.ebfba2d2.png";